import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useModelStore } from '../../stores/modelStore';

export const ProviderToggle: React.FC<{ provider: string; label: string }> = ({ provider, label }) => {
  const providerVisibility = useModelStore((s) => s.providerVisibility);
  const setProviderVisibility = useModelStore((s) => s.setProviderVisibility);
  const enabled = providerVisibility[provider] !== false;

  return (
    <div className="flex items-center gap-2">
      <span className="text-[10px] text-slate-500">显示模型</span>
      <button
        onClick={() => setProviderVisibility(provider, !enabled)}
        className={`relative w-8 h-[18px] rounded-full transition-colors duration-200 ${enabled ? 'bg-cyan-500' : 'bg-white/10'}`}
      >
        <div
          className={`absolute top-[2px] w-[14px] h-[14px] rounded-full bg-white shadow transition-transform duration-200 ${enabled ? 'translate-x-[17px]' : 'translate-x-[2px]'}`}
        />
      </button>
    </div>
  );
};

interface KeyFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  description: React.ReactNode;
  provider: string;
  providerLabel: string;
  linkHref: string;
  linkText: string;
  prefix?: string;
  showBorder?: boolean;
}

export const KeyField: React.FC<KeyFieldProps> = ({
  label, value, onChange, placeholder, description,
  provider, providerLabel, linkHref, linkText,
  prefix, showBorder = true,
}) => (
  <div className={`space-y-4 ${showBorder ? 'pt-4 border-t border-white/5' : ''}`}>
    <div className="flex items-center justify-between">
      <label className="text-xs font-bold text-slate-400 uppercase tracking-wider">{label}</label>
      <div className="flex items-center gap-3">
        <ProviderToggle provider={provider} label={providerLabel} />
        <a href={linkHref} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-[10px] text-cyan-400 hover:text-cyan-300 transition-colors">
          <span>{linkText}</span>
          <ExternalLink size={10} />
        </a>
      </div>
    </div>

    <div className="relative group">
      {prefix && (
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <span className="text-slate-500 font-mono text-xs">{prefix}</span>
        </div>
      )}
      <input
        type="password"
        autoComplete="off"
        className={`w-full bg-black/30 border border-white/10 rounded-xl py-3 text-sm text-white placeholder-slate-600 focus:outline-none focus:border-cyan-500/50 transition-colors font-mono ${prefix ? 'pl-10 pr-4' : 'px-4'}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
    <p className="text-[11px] text-slate-500 leading-relaxed">
      {description}
    </p>
  </div>
);
